import React, { FC } from 'react';
import { Section } from './Section';
import { Grid } from './Grid';
import Spacer from './Spacer';
import { Typography } from './Typography';
import { ImageCard } from './ImageCard';
import { Divider } from './Divider';

interface LinkedPagesProps {
  title: string;
  pageType: string;
  linkedPages: Array<object>;
}

export const LinkedPages: FC<LinkedPagesProps> = ({ title, pageType, linkedPages }) => {
  if (linkedPages.length < 2) {
    return null;
  }

  return (
    <>
      <Section contained>
        <Spacer responsive>
          <Divider />
          {title && (
            <Typography component="h2" variant="displaySmall">
              {title}
            </Typography>
          )}
          <Grid desktopColumns="2">
            {linkedPages.map(({ pageName, relativeUrl, feed }, index) => (
              <ImageCard
                heading={pageName}
                url={relativeUrl}
                intro={feed.shortDescription}
                actionLabel="Learn more"
                tag={pageType}
                tagColour="brand"
                image={feed.featuredImage}
                key={`imc-${index}`}
              />
            ))}
          </Grid>
        </Spacer>
      </Section>
    </>
  );
};
